import { ReactNode } from "react";
import { createPortal } from "react-dom";
import { create } from "zustand";

interface SidebarPageSlotState {
  /** The left menu sidebar's page-section element; null while the sidebar isn't mounted. */
  slot: HTMLElement | null;
  setSlot: (slot: HTMLElement | null) => void;
}

/**
 * Where `SidebarPageSection` renders. `DashboardLeftPanel` registers the element (between the
 * logo and the menu) with `setSlot` as a callback ref.
 */
export const useSidebarPageSlotStore = create<SidebarPageSlotState>((set) => ({
  slot: null,
  setSlot: (slot) => set({ slot }),
}));

/**
 * Renders a page's own section into the left menu sidebar, between the logo and the menu, e.g.
 * Create Proposal's auto-save bar and proposal card. It's a portal, so the content keeps the
 * page's state and contexts. Renders nothing while the sidebar isn't there (or is collapsed,
 * which hides the slot).
 */
const SidebarPageSection = ({ children }: { children: ReactNode }) => {
  const slot = useSidebarPageSlotStore((state) => state.slot);
  return slot ? createPortal(children, slot) : null;
};

export default SidebarPageSection;
